function convertFormData(body: any) {
  const formData = new URLSearchParams();
  if (body) {
    Object.keys(body).forEach((key: any) => {
      formData.append(key, body[key]);
    });
  }
  return formData;
}

export default convertFormData;
